import { CalendarClock } from "lucide-react";
import { BOOKING_URLS } from "@/lib/content";

/**
 * BookButton — opens the Setmore booking page in a new tab.
 *
 * Props:
 *   - track: key into BOOKING_URLS (default "general")
 *   - variant: "primary" | "gold" | "outline" | "ghost" (default "gold")
 *   - children: button label
 *   - testId: data-testid override
 *   - icon: show calendar icon (default true)
 */
export default function BookButton({
  track = "general",
  variant = "gold",
  children = "Book Consultation",
  testId,
  icon = true,
  className = "",
  size = "md",
}) {
  const url = BOOKING_URLS[track] || BOOKING_URLS.general;
  const cls =
    variant === "primary"
      ? "btn-primary"
      : variant === "outline"
      ? "btn-outline"
      : variant === "ghost"
      ? "btn-ghost"
      : "btn-gold";

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className={`${cls} ${size === "sm" ? "!px-5 !py-2.5 !text-xs" : ""} ${className}`}
      data-testid={testId || `book-${track}`}
    >
      {icon && <CalendarClock className="w-4 h-4" />}
      {children}
    </a>
  );
}
